import RulesBlock from '../Rules/RulesBlock'
import { useTranslation } from 'react-i18next'
import './tos.css'

export default function ToS() {
    const updateDate = '29.04.2024'
    const { t } = useTranslation()
    return (
        <main>
            <div className="xbox__body rules">
                <div className="xbox__div-1 rules__table">
                    <RulesBlock title={t('tos.main.title')} items={[t('tos.main.text1'), t('tos.main.text2'), t('tos.main.text3'), t('tos.main.text4')]} categoryIndex={1}/>
                    <RulesBlock title={t('tos.administration.title')} items={[t('tos.administration.text1'), t('tos.administration.text2'), t('tos.administration.text3'), t('tos.administration.text4')]} categoryIndex={2}/>
                    <div className="rules__block_item">
                        {t('tos.abuse')} <a href="mailto:contact@rustylifes.com" className='rules__block_url'>contact@rustylifes.com</a>
                    </div>
                    <div className="rules__block_item right">
                        {t('tos.updated')} {updateDate}
                    </div>
                </div>
            </div>
        </main>
    )
}